<template>
  <div>
    <!-- 面包屑 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>会员中心</el-breadcrumb-item>
      <el-breadcrumb-item>会员列表</el-breadcrumb-item>
    </el-breadcrumb>
    <el-input size="mini" placeholder="请输入手机号进行搜索"
              v-model="customerRequest.phone"
              @keyup.enter.native="queryCustomerList()"
              style="width: 200px;padding-bottom: 5px"></el-input>
    <el-input size="mini" placeholder="请输入姓名进行搜索"
              v-model="customerRequest.name"
              @keyup.enter.native="queryCustomerList()"
              style="width: 200px;padding-bottom: 5px"></el-input>
<!--    <el-input size="mini" placeholder="请输入刀具号进行搜索"-->
<!--              v-model="customerRequest.knife"-->
<!--              @keyup.enter.native="queryCustomerByKnifeText()"-->
<!--              style="width: 200px;padding-bottom: 5px"></el-input>-->
    <el-button size="mini" @click="queryCustomerList">查询</el-button>
    <el-table height="510px" :data="customerList" fit border stripe="stripe" :header-cell-style="{background:'#eff3f8', color:'#333'}"
              :row-style="{height: '0'}">
      <el-table-column
        prop="orgName"
        label="合并前门店"
        align="center">
      </el-table-column>
      <el-table-column
        prop="oldCustomerName"
        label="合并前姓名"
        align="center">
      </el-table-column>
      <el-table-column
        prop="oldPhone"
        label="合并前手机"
        align="center">
      </el-table-column>
      <el-table-column
        prop="oldKnife"
        label="合并前刀具号"
        align="center">
      </el-table-column>
      <el-table-column
        label="合并后姓名"
        align="center">
        <template slot-scope="scope">
          <el-link type="primary"
                   @click.prevent="toDetail(scope.row.newId)" >{{scope.row.newCustomerName}}</el-link>
        </template>
      </el-table-column>
      <el-table-column
        prop="newPhone"
        label="合并后手机"
        align="center">
      </el-table-column>
    </el-table>
    <div style="margin-top: 3px;">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageTotal">
      </el-pagination>
    </div>
  </div>
</template>
<script>
export default {
  data(){
    return{
      pageTotal:0,
      currentPage:1,
      pageSize:20,
      customerList:[],
      customerRequest:{
        pageNum: '',
        pageSize: '',
        name: '',
        phone:'',
        orgId:'',
        knife:'',
        queryText:''
      }
    }
  },
  methods:{
    queryCustomerList(){
      this.pageTotal = 0;
      if(this.customerRequest.phone == '' && this.customerRequest.name == ''){
        this.customerList = [];
        return;
      }
      this.loadCustomerCount();
      this.loadCustomers();
    },
    async loadCustomerCount(){
      const {data:res} = await this.$http.post(`/query/old/customer/count`, this.customerRequest)
      this.pageTotal = res.totalPage;
    },
    async loadCustomers(){
      this.customerRequest.pageNum = this.currentPage;
      this.customerRequest.pageSize = this.pageSize;
      const {data:res} = await this.$http.post(`/query/old/customer/list`, this.customerRequest)
      this.customerList = res.data;
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.loadCustomers();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.loadCustomers();
    },
    toDetail(item){
      this.$router.push({path:'/card',query:{id:item}});
    },
  },
}
</script>

<style lang="less" scoped>
.container{
  height: 90vh;
  overflow-y: hidden;
}
.between{
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  height: 92vh;
  background-color: #eff3f8;
}
.left_con{
  display: flex;
  justify-content: start;
  height: 100%;
  overflow-y: auto;
  //flex: 1;
  width: auto;
  //border: 1px solid;
  margin: 10px 0;
  //width: 100px;
}
.table_container{
  flex: 1;
  width: 800px;
  height: 100%;
}
.left_inner_con{
  width: 300px;
  height: 98%;
  overflow-y: auto;
  background-color: #F2F6FC;
}
.el-table, .el-table__cell {
  /deep/ th {
    padding: 2px ;
  }
  /deep/ td {
    padding: 2px ;
  }
}
.box-card{
  margin: 10px 10px 10px 10px;
  height: 87%;
}
/deep/ .el-dialog{
  background: #fafaff !important;
}

/deep/ .el-dialog__header{
  padding: 15px 20px 10px;
}

/deep/ .el-dialog__body{
  padding: 5px 25px;
  color:#606266;
  font-size:14px;
  word-break:break-all;
}

/deep/ .el-drawer__header{
  z-index: 1;
  position: relative;
  margin-bottom:0;
  color: #333 !important;
  .el-dialog__title{
    color: #333;
  }
  .el-dialog__close{
    color: #333 !important;
  }
}
.dialog-footer{
  display: flex;
  margin: 10px 10px 10px 0;
  justify-content: center;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/OldCustomer.vue